import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-lg' : 'bg-white shadow-md'}`}>
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center cursor-pointer">
            <img
              src="https://static.readdy.ai/image/2b1409af55cbbc24ae624602859a344f/49982b335b96708abcb5cab4610886b0.png"
              alt="KGM Danışmanlık"
              className="h-16"
            />
          </Link>

          <div className="hidden md:flex items-center gap-10">
            <a href="/#hizmetler" className="text-sm font-semibold text-[#2D3436] hover:text-[#C17F59] transition-colors cursor-pointer">
              Hizmetler
            </a>
            <a href="/#hakkimizda" className="text-sm font-semibold text-[#2D3436] hover:text-[#C17F59] transition-colors cursor-pointer">
              Hakkımızda
            </a>
            <Link to="/blog" className="text-sm font-semibold text-[#C17F59] transition-colors cursor-pointer">
              Blog
            </Link>
            <a href="/#iletisim" className="text-sm font-semibold text-[#2D3436] hover:text-[#C17F59] transition-colors cursor-pointer">
              İletişim
            </a>
            <a href="tel:+905543791632" className="bg-[#C17F59] text-white px-7 py-3 rounded-lg text-sm font-semibold hover:bg-[#A66B47] transition-all hover:shadow-lg whitespace-nowrap cursor-pointer">
              Hemen Arayın
            </a>
          </div>

          <button className="md:hidden text-[#2D3436]">
            <i className="ri-menu-line text-2xl"></i>
          </button>
        </div>
      </div>
    </nav>
  );
}
